export default {
      id: "basin-usage",
      viewBox: "0 0 78.92 31.64",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#basin",
      toString: function () {
        return this.url;
      }
    }